export default "<p>cotizaciones works!</p>\n"